// ─── Días de horas dados por buenos (sesión 34) ───────────────────────────────
// El aviso de horas del último día laborable (Dashboard y Control de horas) se quita cuando la persona lo da por
// bueno: "No trabajé ese día" (0 h) o "Está bien así" (jornada parcial real). Se recuerda en este navegador, sin
// escribir en Firestore: es un recordatorio, no un dato del estudio. Si el navegador no deja guardar, vuelve a salir.
const clave = (uid) => `metron_dias_revisados_${uid}`;

export function leerDiasRevisados(uid) {
  if (!uid) return [];
  try {
    const v = JSON.parse(window.localStorage.getItem(clave(uid)) || '[]');
    return Array.isArray(v) ? v : [];
  } catch (e) { return []; }
}

export function marcarDiaRevisado(uid, fecha) {
  if (!uid || !fecha) return;
  try {
    const lista = leerDiasRevisados(uid).filter(f => f !== fecha);
    lista.push(fecha);
    window.localStorage.setItem(clave(uid), JSON.stringify(lista.slice(-30)));
  } catch (e) { /* sin almacenamiento: no pasa nada */ }
}
